import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Observable, forkJoin } from 'rxjs';
import { map, takeUntil, switchMap } from 'rxjs/operators';
import { CustomerTerminalDetail } from 'src/app/models/entities/customer-terminal-detail';
import { CustomerTerminalMain } from 'src/app/models/entities/customer-terminal-main';
import { TerminalHistory } from 'src/app/models/entities/terminal-history';
import { VContract } from 'src/app/models/entities/v-contract';
import { VLogoCustomer } from 'src/app/models/entities/v-logo-customer';
import { VTerminal } from 'src/app/models/entities/v-terminal';
import { ContractService } from 'src/app/services/contract.service';
import { CustomerTerminalDetailService } from 'src/app/services/customer-terminal-detail.service';
import { CustomerTerminalMainService } from 'src/app/services/customer-terminal-main.service';
import { LogoService } from 'src/app/services/logo.service';
import { NbsUserService } from 'src/app/services/nbs-user.service';
import { TerminalHistoryService } from 'src/app/services/terminal-history.service';
import { TerminalService } from 'src/app/services/terminal.service';

@Component({
  selector: 'app-customer-terminal-update',
  templateUrl: './customer-terminal-update.component.html',
  styleUrls: ['./customer-terminal-update.component.css']
})
export class CustomerTerminalUpdateComponent implements OnInit {

  destroy$ = new Subject<void>();
  form: FormGroup;
  customers$: Observable<VLogoCustomer[]>;
  contracts$: Observable<VContract[]>;
  terminals$: Observable<VTerminal[]>;
  targetTerminals: VTerminal[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private contractService: ContractService,
    private logoService: LogoService,
    private terminalService: TerminalService,
    private customerTerminalMainService: CustomerTerminalMainService,
    private customerTerminalDetailService: CustomerTerminalDetailService,
    //private terminalHistoryService: TerminalHistoryService,
    private userService: NbsUserService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getCustomers();
    this.getById();
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      groupCode: [""],
      groupName: [""],
      customerCode: [""],
      customerId: ["", Validators.required],
      contractId: ["", Validators.required],
      processDate: [new Date],
      isActive: true
    })
  }

  getById() {
    const customerTerminalId = parseInt(this.activatedRoute.snapshot.paramMap.get('customerTerminalId'));
    this.customerTerminalMainService.getById(customerTerminalId).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.getContracts(data.data.customerId);
      this.form.patchValue(data.data);
      this.contractService.getById(data.data.contractId).pipe(takeUntil(this.destroy$)).subscribe(result => {
        this.getTerminals(result.data.portalId);
      })
      this.terminalService.getCustomerTerminals(customerTerminalId).pipe(takeUntil(this.destroy$)).subscribe(result => {
        this.targetTerminals = result.data;
      })
    })
  }

  getCustomers() {
    this.customers$ = this.logoService.getCustomers().pipe(map(result => result.data));
  }

  getContracts(customerId: number) {
    this.contracts$ = this.contractService.getListByCustomerId(customerId).pipe(map(result => result.data));
  }

  getTerminals(portalId: number) {
    this.terminals$ = this.terminalService.getListByPortalId(portalId, false).pipe(map(result => result.data));
  }



  update() {
    if (this.form.valid && this.targetTerminals.length > 0) {
      let customerTerminalMain: CustomerTerminalMain = this.form.getRawValue();
      customerTerminalMain.userId = this.userService.getUserId();
      forkJoin({
        firstCall: this.terminalService.getCustomerTerminals(customerTerminalMain.id).pipe(
          switchMap(post => this.terminalService.statusUpdateRangeFalse(post.data).pipe(
            switchMap(() => this.terminalService.statusUpdateRangeTrue(this.targetTerminals))))
        ),
        secondCall: this.customerTerminalDetailService.deleteByMainId(customerTerminalMain.id).pipe(
          switchMap(() => this.customerTerminalMainService.update(customerTerminalMain).pipe(
            switchMap(() => this.customerTerminalDetailService.addRange(this.createDetails(customerTerminalMain.id)))
          ))
        )
      }
      ).pipe(takeUntil(this.destroy$)).subscribe(
        result => {
          this.toastrService.success(result.secondCall.message, "İşlem başarılı.");
          this.router.navigateByUrl('/customer-terminal');
        },
        er => {
          this.toastrService.error(er.error.message, "HATA!");
        }
      )
    }
  }

  createDetails(customerTerminalMainId: number): CustomerTerminalDetail[] {
    let details: CustomerTerminalDetail[] = [];
    for (let i = 0; i < this.targetTerminals.length; i++) {
      let detail: CustomerTerminalDetail = {
        id: 0,
        customerTerminalMainId: customerTerminalMainId,
        terminalId: this.targetTerminals[i].id,
        isActive: true
      };
      details.push(detail);
    }
    return details;
  }


  ngOnDestroy(): void {
    this.destroy$.next;
  }

}
